export type TenantRuntimeSettings = {
  systemName?: string | null;
  systemNameZh?: string | null;
  systemNameEn?: string | null;
  domainName?: string | null;
  logoUrl?: string | null;
  timezone?: string | null;
};

let runtimeSettings: TenantRuntimeSettings = {};

export function setTenantRuntimeSettings(settings?: TenantRuntimeSettings) {
  runtimeSettings = settings ?? {};
}

export function localizedSystemName(
  settings: TenantRuntimeSettings | null | undefined,
  locale: string | undefined,
  defaultName: string,
): string {
  const chinese = settings?.systemNameZh || settings?.systemName;
  return locale === 'en-US'
    ? settings?.systemNameEn || chinese || defaultName
    : chinese || settings?.systemNameEn || defaultName;
}

export function tenantSystemName(defaultName: string, locale?: string): string {
  return localizedSystemName(runtimeSettings, locale, defaultName);
}

export function tenantTimezone(): string | undefined {
  return runtimeSettings.timezone || undefined;
}

export function formatTenantDateTime(value?: string | null): string {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.valueOf())) return value;
  return new Intl.DateTimeFormat(undefined, {
    dateStyle: 'short',
    timeStyle: 'medium',
    timeZone: tenantTimezone(),
  }).format(date);
}

export function formatTenantDate(value?: string | null): string {
  if (!value) return '-';
  const dateOnly = /^(\d{4}-\d{2}-\d{2})/.exec(value);
  if (dateOnly?.[1]) return dateOnly[1];
  const date = new Date(value);
  if (Number.isNaN(date.valueOf())) return value;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
